// extracted by mini-css-extract-plugin
export default {"grid":"PokemonList_grid__d0uOy","item":"PokemonList_item__xhDTc","rotate-vert-center":"PokemonList_rotate-vert-center__Wzkp-"};